<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.path"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <api-select />
  </div>
</template>

<script>
import apiSelect from './components/apiSelect.vue'
export default {
  name: 'App',
  components: {
    apiSelect
  }
}
</script>

<style>
@import url('./common/base.css');
@import url('./common/scroll.css');
#app{
  height: 100%;
}
*{
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue